import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Stylesheet from 'stilr';
import Typography from '@mui/material/Typography';

const styles = Stylesheet.create({
  container: {
    maxWidth: 600,
    margin: 'auto'
  }
});

export default class NarrowContainer extends Component {
  static propTypes = {
    className: PropTypes.string,
    header: PropTypes.string
  };

  render() {
    const { className = '', children, header } = this.props;
    return (
      <div className={`${styles.container} ${className}`}>
        {header ? (
          <Typography variant="h5" gutterBottom>
            {header}
          </Typography>
        ) : null}

        {children}
      </div>
    );
  }
}